























import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import "./styles.scss";

@Component({})
export default class GameSelector extends Vue {
  @Prop()
  nextPlayer: string;

  @Prop()
  winner: string;

  @Prop()
  disableControls: boolean;

  @Provide()
  opponent = "player";

  startGame() {
    this.$emit("start", this.opponent);
  }
}
